import { BadgeDomain } from "../../Abstractions/BadgeDomain";

export function OrderSeriesBadge({ size, className, onClick }) {
  return <BadgeDomain onClick={onClick} className={className ?? "upper mb-1"} size={size} bg="navy">Zlecenie cykliczne</BadgeDomain>;
}